import React, { useEffect, useState } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const aboutSubMenu = [{
  name: 'Mission',
  href: '#about'
}, {
  name: 'Aim and Objectives',
  href: '#about'
}, {
  name: 'Learning Support',
  href: '#about'
}, {
  name: 'Result',
  href: '#about'
}, {
  name: 'Facilities',
  href: '#about'
}, {
  name: 'Security and Safety',
  href: '#about'
}, {
  name: 'College Registration',
  href: '#about'
}];
const navLinks = [{
  name: 'Home',
  href: '#home'
}, {
  name: 'About',
  href: '#about',
  hasDropdown: true
}, {
  name: 'Academic',
  href: '#academic'
}, {
  name: 'Admission',
  href: '#admission'
}, {
  name: 'Departments',
  href: '#departments'
}, {
  name: 'Gallery',
  href: '#gallery'
}, {
  name: 'Notice',
  href: '#notice'
}, {
  name: 'Contact',
  href: '#contact'
}];
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  const [isMobileAboutOpen, setIsMobileAboutOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleLinkClick = () => {
    setIsMobileMenuOpen(false);
    setIsMobileAboutOpen(false);
  };
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-primary/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`} data-id="element-192">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-193">
        <div className="flex items-center justify-between h-20" data-id="element-194">
          {/* Logo */}
          <a href="#home" className="flex items-center space-x-3" data-id="element-195">
            <img src="https://cdn.magicpatterns.com/uploads/e8yMcZn3ceuH6u64yRTz86/manarat-new-logo.png" alt="MDIC Logo" className="h-16 w-16" data-id="element-196" />
            <div className="hidden md:block" data-id="element-197">
              <div className="text-white font-heading font-semibold text-2xl leading-tight" data-id="element-198">
                Manarat Dhaka
              </div>
              <div className="text-white/90 text-xs" data-id="element-199">
                International School & College
              </div>
            </div>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-1" data-id="element-200">
            {navLinks.map(link => link.hasDropdown ? <div key={link.name} className="relative" onMouseEnter={() => setIsAboutOpen(true)} onMouseLeave={() => setIsAboutOpen(false)} data-id="element-201">
                  <a href={link.href} className="text-white hover:text-gold px-3 py-2 rounded-md text-sm font-medium transition-colors inline-flex items-center gap-1" data-id="element-202">
                    {link.name}
                    <ChevronDown size={14} className={`transition-transform ${isAboutOpen ? 'rotate-180' : ''}`} data-id="element-203" />
                  </a>
                  <AnimatePresence data-id="element-204">
                    {isAboutOpen && <motion.div initial={{
                opacity: 0,
                y: 8
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: 8
              }} transition={{
                duration: 0.2
              }} className="absolute top-full left-0 mt-1 w-56 bg-white rounded-lg shadow-xl border border-gray-100 overflow-hidden" data-id="element-205">
                        <div className="bg-primary px-4 py-2" data-id="element-206">
                          <span className="text-white font-heading font-semibold text-sm" data-id="element-207">
                            About MDIC
                          </span>
                        </div>
                        {aboutSubMenu.map((item, index) => <a key={item.name} href={item.href} className={`block px-4 py-2.5 text-sm text-text-dark hover:bg-primary/10 hover:text-primary transition-colors ${index < aboutSubMenu.length - 1 ? 'border-b border-gray-100' : ''}`} data-id="element-208">
                            {item.name}
                          </a>)}
                      </motion.div>}
                  </AnimatePresence>
                </div> : <a key={link.name} href={link.href} className="text-white hover:text-gold px-3 py-2 rounded-md text-sm font-medium transition-colors" data-id="element-209">
                  {link.name}
                </a>)}
          </div>

          {/* CTA Buttons */}
          <div className="hidden lg:flex items-center space-x-3" data-id="element-210">
            <a href="#admission" className="bg-gold hover:bg-gold/90 text-white px-5 py-2 rounded-md text-sm font-semibold transition-all" data-id="element-211">
              Apply Now
            </a>
            <a href="#portal" className="bg-primary hover:bg-primary-dark text-white px-5 py-2 rounded-md text-sm font-semibold transition-all border border-white/20" data-id="element-212">
              Student Portal
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden text-white p-2" data-id="element-213">
            {isMobileMenuOpen ? <X size={24} data-id="element-214" /> : <Menu size={24} data-id="element-215" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-216">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-primary/98 backdrop-blur-md" data-id="element-217">
            <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-218">
              {navLinks.map(link => link.hasDropdown ? <div key={link.name} data-id="element-219">
                    <button onClick={() => setIsMobileAboutOpen(!isMobileAboutOpen)} className="flex items-center justify-between w-full text-white hover:text-gold px-3 py-2 rounded-md text-base font-medium transition-colors" data-id="element-220">
                      {link.name}
                      <ChevronDown size={16} className={`transition-transform ${isMobileAboutOpen ? 'rotate-180' : ''}`} data-id="element-221" />
                    </button>
                    <AnimatePresence data-id="element-222">
                      {isMobileAboutOpen && <motion.div initial={{
                opacity: 0,
                height: 0
              }} animate={{
                opacity: 1,
                height: 'auto'
              }} exit={{
                opacity: 0,
                height: 0
              }} className="pl-6 space-y-1" data-id="element-223">
                          {aboutSubMenu.map(item => <a key={item.name} href={item.href} onClick={handleLinkClick} className="block text-white/80 hover:text-gold px-3 py-1.5 rounded-md text-sm transition-colors" data-id="element-224">
                              {item.name}
                            </a>)}
                        </motion.div>}
                    </AnimatePresence>
                  </div> : <a key={link.name} href={link.href} onClick={handleLinkClick} className="block text-white hover:text-gold px-3 py-2 rounded-md text-base font-medium transition-colors" data-id="element-225">
                    {link.name}
                  </a>)}
              <div className="pt-4 space-y-2" data-id="element-226">
                <a href="#admission" onClick={handleLinkClick} className="block w-full bg-gold hover:bg-gold/90 text-white px-5 py-3 rounded-md text-center font-semibold transition-all" data-id="element-227">
                  Apply Now
                </a>
                <a href="#portal" onClick={handleLinkClick} className="block w-full bg-primary hover:bg-primary-dark text-white px-5 py-3 rounded-md text-center font-semibold transition-all border border-white/20" data-id="element-228">
                  Student Portal
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}